module.exports = __webpack_public_path__ + "img/opi-2.95fc815.svg";